/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProviderApiPushResponse } from './providerApiPushResponse';


/**
 * Aggregation of results from sending data to agent apis
 */
export interface PushIrrComponentsResponse { 
    health_response?: ProviderApiPushResponse;
    inventory_response?: ProviderApiPushResponse;
    stats_response?: ProviderApiPushResponse;
}

